import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import styled from 'styled-components'
import { Tooltip as ReactTooltip } from 'react-tooltip'
import AnimatedHeading from 'components/animated-heading-hosting-tec'



class Hosting extends React.Component {

    shouldComponentUpdate() {
        return false
    }

    constructor(props) {
        super(props)
        this.state = {
            height: 0,
            width: 0
        }
    }

    updateDimensions = () => {
        if (this.state.height !== window.innerHeight) {
            this.setState({height: window.innerHeight})
        }
        if (this.state.width !== window.innerWidth) {
            this.setState({width: window.innerWidth})
        }
    }

    
    componentDidMount() {
        this.setState({height: window.innerHeight, width: window.innerWidth})
        window.addEventListener('resize', this.updateDimensions)
    }
    
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions)
    }
      
    render() {

        const Section = styled.section`
            position: relative;
            overflow: hidden;
            background-color: #fff;
            padding: 80px 0 50px 0;
            .heading {
                width: 100%;            
            @media (max-width: 767px) {
                padding: 50px 0 50px 0;           
            }
            @media (min-width:768px) and (max-width:1500px) {
                padding: 50px 0 50px 0;              
            }
        `

        const ServiceRow = styled(Row)`
            margin-top: 10px;
        `
        const ServiceRow1 = styled(Row)`
            margin-top: 50px;
        `
         
         const TecText = styled.p`
            font-size: 18px;
            font-weight: 300;
            color: #555555;            
        `

        const ResponsiveTable = styled.table`
          width: 100%;
          margin-bottom: 1.5em;
          border-spacing: 0;
          
          thead {
            // Accessibly hide <thead> on narrow viewports
            position: absolute;
            clip: rect(1px 1px 1px 1px); /* IE6, IE7 */
            padding: 0;
            border: 0;
            height: 1px; 
            width: 1px; 
            overflow: hidden;
            
            @media (min-width: 48em) {
              // Unhide <thead> on wide viewports
              position: relative;
              clip: auto;
              height: auto;
              width: auto;
              overflow: auto;
            }
            
            th {
              background-color: rgba(104,104,104,1);              
              font-weight: normal;
              text-align: left;
              color: white;
              
              &:first-of-type {
                text-align: left; 
              }
            }
          }
          
          // Set these items to display: block for narrow viewports
          tbody,
          tr,
          th,
          td {
            display: block;
            padding: 0;
            text-align: left;
            white-space: normal;
          }
          
          tr {   
            @media (min-width: 48em) {
              // Undo display: block 
              display: table-row; 
            }
          }
          
          th,
          td {
            padding: .5em;
            vertical-align: middle;
            
            @media (min-width: 30em) {
              padding: .75em .5em; 
            }
            
            @media (min-width: 48em) {
              // Undo display: block 
              display: table-cell;
              padding: .5em;
            }
            
            @media (min-width: 62em) {
              padding: .75em .5em; 
            }
            
            @media (min-width: 75em) {
              padding: .75em; 
            }
          }
          
          caption {
            margin-bottom: 1em;
            font-size: 1em;
            font-weight: bold;
            text-align: center;
            
            @media (min-width: 48em) {
              font-size: 1.5em;
            }
          }
          
          tfoot {
            font-size: .8em;
            font-style: italic;
            
            @media (min-width: 62em) {
              font-size: .9em;
            }
          }
          
          tbody {
            @media (min-width: 48em) {
              // Undo display: block 
              display: table-row-group; 
            }
            
            tr {
              margin-bottom: 1em;
              
              @media (min-width: 48em) {
                // Undo display: block 
                display: table-row;
                border-width: 1px;
              }
              
              &:last-of-type {
                margin-bottom: 0; 
              }
              
              &:nth-of-type(even) {
                @media (min-width: 48em) {
                  background-color: rgba(0,0,0,.12);
                }
              }
            }
            
            th[scope="row"] {
              background-color: rgba(38,137,13,1);
              color: white;              
              
              @media (min-width: 48em) {
                background-color: transparent;
                color: rgba(0,0,0.87);
                text-align: left;
              }
            }
            
            td {
              text-align: right;
              
              @media (min-width: 48em) {                
                text-align: left; 
              }              
              
            }
            
            td[data-type=currency] {
              text-align: right; 
            }
            
            td[data-tooltip-content]:before {
              content: attr(data-tooltip-content);
              float: left;
              font-size: .8em;
              color: rgba(0,0,0,.54);
              
              @media (min-width: 30em) {
                font-size: .9em; 
              }
              
              @media (min-width: 48em) {
                // Don’t show data-tooltip-content labels 
                content: none; 
              }
            } 
          }          
          `

        const Badge = styled.span`
          display:inline-block;
          background-color: #80c800 !important;
          padding:.25em .4em;
          font-size:75%;
          font-weight:700;
          line-height:1;
          text-align:center;
          white-space:nowrap;
          vertical-align:baseline;
          border-radius:.10rem;
          transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
          `        

        return(
          <Section>
            <Container>
              <AnimatedHeading text="SSD vs HDD" />
              <ServiceRow>
                <Col md={12}>
                  <TecText>
                    Cuando se trata de elegir el tipo de almacenamiento para tu servidor dedicado, la elección entre discos SSD
                    (Unidad de Estado Sólido) y discos HDD (Disco Duro) marca una diferencia significativa en el rendimiento
                    y la eficiencia de tu infraestructura.
                  </TecText>
                </Col>
              </ServiceRow>
              <ServiceRow1>
                <Col md={12}>
                  
                    <ResponsiveTable>
                      <thead>
                        <tr>
                          <th scope="col"><Badge>VS</Badge></th>
                          <th scope="col">SSD</th>
                          <th scope="col">HDD</th>
                        </tr>
                      </thead>
                      <tfoot>
                        <tr>
                          <td colspan="7">Fuente: VASCO Solutions.</td>
                        </tr>
                      </tfoot>
                      <tbody>
                        <tr>
                          <th scope="row"> Desempeño</th>
                          <td> Velocidades de lectura/escritura de alto rendimiento</td>
                          <td> Velocidades moderadas de lectura/escritura</td>
                        </tr>
                        <tr>
                          <th scope="row"> Durabilidad</th>
                          <td> Unidades de disco estables reforzadas por la industria</td>
                          <td> Unidades de disco duro estándar</td>
                        </tr>
                        <tr>
                          <th scope="row"> Ideal para</th>
                          <td> Sitios web, aplicaciones y servicios de software</td>
                          <td> Sitios web y servidores de correo</td>
                        </tr>
                        <tr>
                          <th scope="row"> Capacidad</th>
                          <td> Hasta 1,7 TB</td>
                          <td> Hasta 1.000 GB</td>
                        </tr>
                        <tr>
                          <th scope="row"> Eficiencia energética</th>
                          <td> Bajo consumo de energía</td>
                          <td> Alto consumo de energía</td>
                        </tr>                        
                      </tbody>
                    </ResponsiveTable>
                    <ReactTooltip id="tech-hosting-tooltips" place="top" type="dark" effect="float" />
                  
                </Col>
              </ServiceRow1>
            </Container>
          </Section>
        )
    }
}

export default Hosting;